"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var context_1 = require("../context");
function useClientPaging(data, options) {
    var _a = context_1.useListingContext().paging, pageNumber = _a.pageNumber, pageSize = _a.pageSize, setCurrentPage = _a.setCurrentPage;
    var _b = (options || {}).allowOutOfBounds, allowOutOfBounds = _b === void 0 ? false : _b;
    // Split data into pages according to the page size
    var pages = React.useMemo(function () {
        var split = [];
        for (var index = 0; index < data.length; index += pageSize) {
            split.push(data.slice(index, index + pageSize));
        }
        return split;
    }, [data, pageSize]);
    var lastPageNumber = Math.max(pages.length - 1, 0);
    var currentPageNumber = allowOutOfBounds ? pageNumber : Math.min(lastPageNumber, pageNumber);
    // Clamp the page number to a legal value between 0 and the number of pages.
    React.useEffect(function () {
        if (!allowOutOfBounds) {
            if (pageNumber > lastPageNumber) {
                setCurrentPage(lastPageNumber);
            }
            if (pageNumber < 0) {
                setCurrentPage(0);
            }
        }
    }, [pageNumber, lastPageNumber, allowOutOfBounds]);
    var goToNextPage = React.useCallback(function (relativePage) {
        setCurrentPage((relativePage || currentPageNumber) + 1);
    }, [currentPageNumber, setCurrentPage]);
    var goToPreviousPage = React.useCallback(function (relativePage) {
        setCurrentPage((relativePage || currentPageNumber) - 1);
    }, [currentPageNumber, setCurrentPage]);
    return {
        currentPageNumber: currentPageNumber,
        totalItemCount: data.length,
        pageCount: Math.max(pages.length, 1),
        page: pages[currentPageNumber] || [],
        goToNextPage: currentPageNumber < lastPageNumber ? goToNextPage : undefined,
        goToPreviousPage: currentPageNumber > 0 ? goToPreviousPage : undefined
    };
}
exports.default = useClientPaging;
//# sourceMappingURL=useClientPaging.js.map